export const extractUniqueDays = (sessions) => {
    const uniqueDays = [...new Set(sessions.map((session) => session.start_date.split("T")[0]))];
    uniqueDays.sort();
    return uniqueDays;
};

export const htmlToText = (html) => {
    return html.replace(/<[^>]*>?/g, "");
};